 <div>
<!-- Dashboard Content -->
  <main class="content-area">
      <div class="dashboard">
        <app-page-header
          title="Dashboard"
          [subtitle]="welcomeSubtitle"
        ></app-page-header>
        <!-- Stats Grid -->
        <app-stats-grid [cards]="statCards"></app-stats-grid>

      <!-- Charts Grid -->
      <div class="charts-grid">
        <div class="chart-col">
          <app-monthly-chart
            [data]="monthlyRevenueTrend"
            title="Monthly Revenue Trend"
            valueFormat="currency"
          ></app-monthly-chart>
        </div>

        <div class="chart-col">
          <app-category-chart
            [categories]="vendorCategories"
          ></app-category-chart>
        </div>
      </div>

        <!-- Activity Feed -->
         @if (false) {
           <div class="activity-row">
             <app-activity-feed [activities]="recentActivities"></app-activity-feed>
           </div>
         }
    </div>
  </main>
</div>
